import React, { useEffect, useRef } from 'react';

const GSAPTest = () => {
  const testRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (typeof window !== 'undefined' && window.gsap) {
        if (testRef.current) {
          window.gsap.fromTo(testRef.current, 
            {
              opacity: 0,
              y: 50,
              scale: 0.5
            },
            {
              opacity: 1,
              y: 0,
              scale: 1,
              duration: 2,
              ease: "bounce.out"
            }
          );
        }
      } else {
        import('gsap').then((gsap) => {
          if (testRef.current) {
            gsap.default.fromTo(testRef.current,
              {
                opacity: 0,
                y: 50,
                scale: 0.5
              },
              {
                opacity: 1,
                y: 0,
                scale: 1,
                duration: 2,
                ease: "bounce.out"
              }
            );
          }
        }).catch(error => {
        });
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div 
      ref={testRef}
      style={{ opacity: 0 }}
    >
    </div>
  );
};

export default GSAPTest;